import { sendMultipart } from "../../../../../../../../adapters/helpers"

const DocumentosAdapters = {
    
    GET: {

        receive: {

            schema: function (item: any) {

                if (!item) item = {}

                const data = {
                    id: item.idadjunto || '',
                    documento: item.documento || '',
                    idevento: item.idevento || '',
                    idinscripcion: item.idinscripcion || '',
                    idplantilla: item.idplantilla || '',
                    logfecha: item.logfecha || '',
                    logidpersona: item.logidpersona || '',
                    publicaweb: item.publicaweb === '0' ? 'false' : 'true',
                    rutaarchivo: item.rutaarchivo || '',
                    rutathumbnail: item.rutathumbnail || '',
                    tipo: item.tipo || '',
                    url_adjunto: item.url_adjunto || '',
                    nombre: item.nombre || '',

                }

                return data
            },

            adapter: function (data: any) {

                const dataTemp = data?.data?.data

                const items = dataTemp?.map((item: any) => (this.schema(item)))

                return {
                    data: {
                        items
                    },
                    status: data?.status
                }
            }
        },
    },

    POST: {

        receive: {

            schema: function (item: any) {

                if (!item) item = {}

                const data = {
                    data: item.data,
                    message: item.message,
                    status: item.status
                }

                return data
            },

            adapter: function (data: any) {

                const dataTemp = data?.data

                const items = this.schema(dataTemp)

                return {
                    data: items,
                    status: data?.status
                }
            }
        },

        send: {

            schema: function (item: any) {

                if (!item) item = {}

                const data = {
                    idproducto: item.idproducto || '',
                    archivo: item.archivo || '',
                    nombre: item.nombre || '',
                    // tipo: item.tipo || 'D',
                    // publicaweb: item.publicaweb === 'true' ? '1' : '0',
                    // file: item.file || '',
                }

                return data
            },

            adapter: function (data: any) {

                const items = this.schema(data)

                return sendMultipart(items)
            }
        },
    },

    PATCH: {

        receive: {

            schema: function (item: any) {

                if (!item) item = {}

                const data = {
                    data: item.data,
                    message: item.message,
                    status: item.status
                }

                return data
            },

            adapter: function (data: any) {

                const dataTemp = data?.data

                const items = this.schema(dataTemp)

                
                return {
                    data: items,
                    status: data?.status
                }
            }
        },

        send: {

            schema: function (item: any) {

                if (!item) item = {}

                const data = {
                    idevento: item.idevento || '',
                    documento: item.documento || '',
                    tipo: item.tipo || 'D',
                    publicaweb: item.publicaweb === 'true' ? '1' : '0',
                }

                return data
            },

            adapter: function (data: any) {

                const items = this.schema(data)

                return {
                    ...items
                }
            }
        },
    },

    DELETE: {

        receive: {

            schema: function (item: any) {

                if (!item) item = {}

                const data = {
                    message: item.message,
                    status: item.status
                }

                return data
            },

            adapter: function (data: any) {

                const dataTemp = data?.data

                const items = this.schema(dataTemp)

                
                return {
                    data: items,
                    status: data?.status
                }
            }
        },
    },
}

export {
    DocumentosAdapters,
}